import { Grid } from '@mui/material';
import Box from '@mui/material/Box';
import logo from 'assets/logos/logo';
import { bool } from 'prop-types';
import React from 'react';
import BackButton from './BackButton';

const Logo = ({ isBackVisible }) => (
  <Grid
    container
    sx={{
      alignItems: 'center',
      justifyContent: 'space-between',
      display: 'flex',
      padding: '30px 0',
      textAlign: 'center',
      mb: '27px',
    }}
  >
    {isBackVisible ? (
      <div>
        <BackButton />
      </div>
    ) : (
      <Box sx={{ width: 40, height: 38 }} />
    )}
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box
        component="img"
        src={logo}
        alt="logo"
        sx={[
          {
            width: 127,
          },
          theme => ({
            filter: theme.palette.mode === 'dark' ? 'invert(1) hue-rotate(180deg)' : 'invert(0)',
          }),
        ]}
      />
    </Box>

    <Box sx={{ width: 40, height: 38 }} />
  </Grid>
);
Logo.propTypes = {
  isBackVisible: bool.isRequired,
};

export default Logo;
